import { ApiUtils } from '@/lib/utils/api';

export interface RefundRequest {
  paymentId?: string;
  amount?: number;
  reason?: string;
}

export interface RefundResponse {
  success: boolean;
  refund: {
    _id: string;
    amount: number;
    status: string;
    createdAt: string;
  };
}

export class PaymentService {
  private static readonly BASE_URL = 'payments';

  static async refundPayment(paymentId: string, data: RefundRequest): Promise<RefundResponse> {
    const response = await ApiUtils.post<{ data: RefundResponse }>(`${this.BASE_URL}/refund`, {
      paymentId,
      ...data,
    });
    return response.data;
  }

  static async refundByRideId(rideId: string, data: RefundRequest): Promise<RefundResponse> {
    const response = await ApiUtils.post<{ data: RefundResponse }>(`${this.BASE_URL}/ride/${rideId}/refund`, data);
    return response.data;
  }
}
